import ky from "ky"
import { afterHooks } from "./http/hooks"
import { http } from "./http"
import { IUserBase } from "../routes/Base/Support/UserManagement/types"

export const checkActiveUser = async (token: string) => {
  await ky("/api/users/user-data", {
    retry: 2,
    throwHttpErrors: true,
    headers: {
      Authorization: "Bearer " + token,
    },
    hooks: {
      afterResponse: [afterHooks.handleEmptyResponse, afterHooks.handleErrors],
    },
  })

  return true
}

export const createUser = (user: IUserBase) => {
  return http.post("users/assign", { json: user })
}

export const validateUser = (user: IUserBase) => {
  return http.post("users/assign/validate", { json: user })
}
